import { makeStyles } from "@mui/styles";
import { createTheme } from "@mui/material/styles";
const theme = createTheme();

const useTestIITStyles = makeStyles(() => ({
  container: {
    padding: 0,
    marginLeft: "auto",
    maxWidth: "100% !important",
  },
  header: {
    position: "fixed",
    marginLeft: "auto",
    top: 0,
    width: "100%",
    zIndex: 1000,
    backgroundColor: "white",
    borderBottom: "1px solid #ccc",
  },
  content: {
    display: "flex",
    marginTop: "150px",
    height: "calc(100vh - 150px)",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      marginTop: "300px",
      height: "auto",
    },
    "@media (min-width: 800px) and (max-width: 898px)": {
    marginTop: "100px",
    },
  },
  left: {
    flexGrow: 1,
    overflowY: "hidden",
    backgroundColor: "#f5f5f5",
    marginTop: "10px",
  },
  right: {
    transition: "width 0.3s ease",
    backgroundColor: "#fff",
  },
}));

export default useTestIITStyles;
